import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import EnhancedTableHead from '../EnhancedTableHead'
import EnhancedTableToolbar from '../EnhancedTableToolbar'
import {getCategoryAuthList, approveCategoryAuth, deleteCategoryAuth} from '../../../../apis/api';

const Error = () => (<div>Error</div>);

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });

    return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    thead: {
        backgroundColor: theme.palette.grey[300],
    },
    cancel: {
        '&:hover': {
            borderColor: theme.palette.error.dark,
        },
        marginLeft: theme.spacing(2),
        color: theme.palette.error.dark,
        borderColor: theme.palette.error.main,
    },
    approval: {
        '&:hover': {
            borderColor: theme.palette.success.dark,
        },
        marginLeft: theme.spacing(2),
        color: theme.palette.success.dark,
        borderColor: theme.palette.success.main,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

export default function EnhancedTable(props) {
    const {filterProps} = props;
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('name');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [rows, setRows] = React.useState([]);
    const [callMyAuthList, setCallMyAuthList] = useState(false);

    const headCells = [
        {id: 'accountId', numeric: false, disablePadding: true, label: 'ID'},
        {id: 'name', numeric: false, disablePadding: false, label: 'name'},
        {id: 'category1Name', numeric: false, disablePadding: false, label: 'category1'},
        {id: 'category2Name', numeric: false, disablePadding: false, label: 'category2'},
        {id: 'use_yn', numeric: false, disablePadding: false, label: 'status'},
    ];

    const handleRefreshClick = (event) => {
        event && event.preventDefault();

        setOrder('asc');
        setOrderBy('name');
        setSelected([]);
        setPage(0);
        setDense(false);
        setRowsPerPage(5);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n.idx);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, category1Name) => {
        const selectedIndex = selected.indexOf(category1Name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, category1Name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const errorHandler = () => <Error />;

    const handleApprovalClick = (event, idx) => {
        const result = rows.find(x => x.idx === idx);
        const {accountId, use_yn, category2Code} = result;

        if (use_yn === 1) {
            deleteCategoryAuth(accountId, category2Code)
                .then(res => {
                    if (res.result) {
                        alert('권한 취소가 완료되었습니다.');
                        setCallMyAuthList(false);
                        handleRefreshClick();
                        return;
                    }
                    alert('권 취소가 완료되지 않았습니다. 다시 시도해주세요.');
                }).catch(() => {
                    return errorHandler();
                });
        } else {
            approveCategoryAuth(accountId, category2Code)
                .then(res => {
                    if (res.result) {
                        alert('권한 승인이 완료되었습니다.');
                        setCallMyAuthList(false);
                        handleRefreshClick();
                        return;
                    }
                    alert('권한 승인이 완료되지 않았습니다. 다시 시도해주세요.');
                }).catch(() => {
                    return errorHandler();
                });
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    const isSelected = (idx) => selected.indexOf(idx) !== -1;

    // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    const [originalRows, setOriginalRows] = useState([]);
    useEffect(() => {
        if (callMyAuthList) return;

        setCallMyAuthList(true);
        getCategoryAuthList()
            .then(res => {
                if (res.length > 0) {
                    const result = res.map((v, i) => ({...v, idx: i}));
                    setOriginalRows(result);
                    setRows(result);
                    return;
                }
                return errorHandler();
            }).catch(() => {
                return errorHandler();
            });
    }, [callMyAuthList]);

    useEffect(() => {
        if (originalRows.length > 0) {
            const {accountId, name, category1Name, category2Name} = filterProps;
            if (!accountId && !name && !category1Name && !category2Name) {
                setRows(originalRows);
                return;
            }

            const getIncludeFilterValue = obj => Object.keys(obj).reduce(function(r, e) {
                if (obj[e]) r[e] = obj[e];
                return r;
            }, {});
            const filterRows = originalRows.filter(v => {
                return Object.keys(getIncludeFilterValue(filterProps)).every(filterValue => v[filterValue] === filterProps[filterValue]);
            });
            setRows(filterRows);
        }
    }, [originalRows, filterProps]);

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <EnhancedTableToolbar
                    title={'Category Request List'}
                    numSelected={selected.length}
                    onRefreshClick={handleRefreshClick}
                />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            headCells={headCells}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row.idx);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row.idx}
                                            selected={isItemSelected}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    checked={isItemSelected}
                                                    inputProps={{'aria-labelledby': labelId}}
                                                    onClick={(event) => handleClick(event, row.idx)}
                                                />
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row" padding="none">
                                                {row.accountId}
                                            </TableCell>
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell>{row.category1Name}</TableCell>
                                            <TableCell>{row.category2Name}</TableCell>
                                            <TableCell>
                                                {row.use_yn === 1 ? 'Done' : 'Waiting'}
                                                {row.use_yn === 1 ? (
                                                    <Button
                                                        className={classes.cancel}
                                                        variant="outlined"
                                                        color="secondary"
                                                        size="small"
                                                        onClick={(event) => handleApprovalClick(event, row.idx)}
                                                    >
                                                        cancel
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        className={classes.approval}
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        onClick={(event) => handleApprovalClick(event, row.idx)}
                                                    >
                                                        apply
                                                    </Button>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {/*{emptyRows > 0 && (*/}
                            {/*    <TableRow style={{height: (dense ? 33 : 53) * emptyRows}}>*/}
                            {/*        <TableCell colSpan={6}/>*/}
                            {/*    </TableRow>*/}
                            {/*)}*/}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
            <FormControlLabel
                control={<Switch checked={dense} onChange={handleChangeDense}/>}
                label="Dense padding"
            />
        </div>
    );
}
